import * as React from 'react';
import { ManualAccess, CodeStatus } from '../../../../../../api/PropertyIntegration';
import ManualAccessRow from './ManualAccessRow';
import NewManualAccessRow from './NewManualAccessRow';
import { useState } from 'react';
import Button from '../../../../../common/form/Button';
import Row from 'reactstrap/lib/Row';

interface Props {
    deleteCodes: (codeIds: number[]) => void;
    addCode: (code: string, name: string) => void;
    codes: ManualAccess[];
}

const ManualAccessDisplay = (props: Props) => {
    let [selectedCodeIds, setSelectedCodeIds] = useState<number[]>([]);

    const selectCode = (clickedCodeId: number) => {
        if (selectedCodeIds.includes(clickedCodeId)) {
            setSelectedCodeIds(selectedCodeIds.filter(codeId => codeId !== clickedCodeId));
        } else {
            setSelectedCodeIds([...selectedCodeIds, clickedCodeId]);
        }
    };

    const confirmDelete = () => {
        if (
            !(
                props &&
                props.codes &&
                props.codes
                    .filter(access => access.codeStatus === CodeStatus.InUse)
                    .some(access => selectedCodeIds.includes(access.id)) &&
                !confirm(
                    'One or more selected codes is in use by a prospect. ' +
                    'If you have removed the code, their tour may be affected.'
                )
            )
        ) {
            props.deleteCodes(selectedCodeIds);
        }
    };

    return (
        <>
            {props.codes.map(code => (
                <ManualAccessRow
                    key={code.id}
                    code={code}
                    selected={selectedCodeIds.includes(code.id)}
                    onClickCode={selectCode}
                />
            ))}
            <NewManualAccessRow onCodeAdd={props.addCode} />
            {selectedCodeIds.length > 0 && (
                <Row>
                    <Button text="Delete Selected" onClick={confirmDelete} />
                </Row>
            )}
        </>
    );
};

export default ManualAccessDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/manualAccessControls/ManualAccessDisplay.tsx